import { render, staticRenderFns } from "./ConnyAvatar.vue?vue&type=template&id=bcba5156&scoped=true&"
import script from "./ConnyAvatar.vue?vue&type=script&lang=js&"
export * from "./ConnyAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ConnyAvatar.vue?vue&type=style&index=0&id=bcba5156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcba5156",
  null
  
)

export default component.exports